<template>
  <div class="wrap">
    <div class="login_user">
      <img src="../../assets/images/logo.jpg"
           alt="">
      <!--<span v-if="wxuser">{{wxuser.uName?wxuser.uName:(wxuser.uUsername?wxuser.uUsername:'')}}</span>-->
    </div>
    <ul class="formRegister">
      <li v-for="(item,index) in info"
          :class="{'codelis':index==2?true:false}"
          :key="index"><span v-if="index<3"
              class="must">* </span> <span class="formName">{{item.name}}</span><input type="text"
               :placeholder="item.place"
               v-model="item.value">
        <button type="button"
                v-if="index==2"
                @click="getCode"
                id="code"
                :disabled="disable">{{code}}</button>
      </li>

    </ul>
    <button id="submit_btn"
            @click="register"><span>注册并登录</span></button>
    <p class="tab">
      <router-link :to="{name:'Login'}">已有账号,立即登录</router-link>
    </p>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
export default {
  data () {
    return {
      wxuser: null,
      source: localStorage.getItem('source'),
      code: '获取验证码',
      disable: false,
      info: [
        { name: "姓名", place: '姓名', value: '' },
        { name: "邮箱", place: '邮箱', value: '' },
        { name: "手机号", place: '手机号', value: '' },
        { name: "验证码", place: '请输入验证码', value: '' },
        { name: "单位", place: '请输入医院名称/企业名称', value: '' },
        // { name: "电子邮箱", place: '请输入电子邮箱', value: '' },
        // { name: "职称", place: '请输入职称', value: '' },
      ],
    }
  },
  props: {},
  methods: {
    //新用户注册
    register () {
      let reg = new RegExp("^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$"); //正则表达式
      if (this.info[0].value == '') {
        this.topTips('请输入姓名！');
        return false;
      }
      if (this.info[1].value == '') {
        this.topTips('请输入邮箱！');
        return false;
      }
      
      if (!reg.test((this.info[1].value))) {
        this.$toast.error('请输入正确格式的邮箱！！');
        return false;
      }


      if (this.info[2].value == '') {
        this.topTips('请输入手机号！');
        return false;
      }
      if (this.info[3].value == '') {
        this.topTips('请输入验证码！');
        return false;
      }
      let params = {
        name: this.info[0].value.trim(),
        mail: this.info[1].value.trim(),
        phone: this.info[2].value.trim(),
        identify: this.info[3].value.trim(),
        org: this.info[4].value,
        // post: this.info[5].value,
        source: this.source
        // id:this.wxuser?(this.wxuser.uId?this.wxuser.uId:''):'',
      };
      console.log(params);
      this.$postHttp(AppSetting.baseUrl + '/student/register', params).then(async(res) => {
        //   console.log(res);
        if (res.data.code == 0) {
          await loginService.setLoginUser(res.data.student)
          this.toast('注册成功！');
          setTimeout(() => {
            // window.history.go(-1);
            //注册完成之后跳转行业标签选择页
            this.$router.push({
              name: "Userlable",
            })
          }, 2000)
        } else if (res.data.code == 1000) {
          this.topTips(res.data.msg);
        } else if (res.data.code == 2003) {
          this.topTips('验证码错误！');
        } else if (res.data.code == 2001) {
          this.topTips('验证码过期！');
        } else if (res.data.code == 2005) {
          this.topTips('用户已存在，请直接登录！');
        } else {
          this.topTips('注册失败');
        }
      })
    },
    getCode () {
      var phone=this.info[2].value;
      
      if (phone == '') {
        this.topTips('请输入手机号！');
        return false;
      }

      const obtn = document.getElementById('code');
      obtn.style.color = '#333333';

      this.$postHttp(AppSetting.baseUrl + '/login/identify', { phone: phone, type: 'REG', oper: 'reg' }).then((res) => {
        console.log(res);
        if (res.data.code == 2007) {
          this.topTips('验证码发送失败');
        } else if (res.data.code == 0) {

          let num = 59;
          this.code = num + 's后重发';
          this.disable = true;
          let code = setInterval(() => {
            num--;
            this.code = num + 's后重发';
            if (num < 1) {
              this.disable = false;
              obtn.style.color = '#007EFF';
              this.code = '重新获取';
              clearInterval(code)
            }
          }, 1000)
          // this.toast('验证码发送成功');
        } else if (res.data.code == 2008) {
          this.topTips('此手机号已被绑定!');
        }
      });
    },
  },
  computed: {},
  async mounted () {
    this.wxuser=await loginService.getLoginUser();
    document.title = '注册'
  }
}
</script>
<style scoped lang="scss">
.wrap {
  background: #ffffff;
  min-height: 100vh;
}
.login_user {
  text-align: center;
  width: 7.5rem;
  height: 2.5rem;
  background: url("../../assets/images/meBg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    font-size: 0.4rem;
    font-weight: bold;
    color: #ffffff;
  }
  img {
    width: 1.2rem;
    height: 1.2rem;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    margin-bottom: 0.12rem;
    margin-top: 0.43rem;
  }
  margin-bottom: 0.75rem;
}
.formRegister {
  font-size: 0.32rem;
  padding: 0.69rem 0.75rem 0rem 0.49rem;
  li {
    margin-bottom: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    input {
      width: 4.6rem;
      height: 0.8rem;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 10px;
      font-size: 0.28rem;
      padding: 0 0.19rem;
      outline: none;
      box-sizing: border-box;
    }
    input::placeholder {
      font-size: 0.28rem;
      color: #999999;
    }
  }

  .codelis {
    input {
      width: 2.6rem !important;
    }
    /*button{*/
    /*display: inline-block;*/
    /*outline: none;*/
    /*width:1.8rem;*/
    /*height:0.8rem;*/
    /*background:rgba(255,255,255,1);*/
    /*border:1px solid #CCCCCC;*/
    /*border-radius:10px;*/
    /*color: #999999;*/
    /*font-size: 0.26rem;*/
    /*margin-left: 0.2rem;*/
    /*}*/
    button {
      margin-left: 0.2rem;
      width: 1.8rem;
      height: 0.8rem;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(204, 204, 204, 1);
      box-sizing: border-box;
      border-radius: 5px;
      font-size: 0.26rem;
      color: #666666;
    }
  }
}
.tab {
  text-align: center;
  padding-top: 0.2rem;
  font-size: 0.24rem;
  a {
    color: #128fff;
  }
}
.must {
  color: #ff0000;
  font-size: 0.28rem;
}
.formName {
  display: inline-block;
  width: 1.17rem;
  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines;
  margin-right: 0.24rem;
  white-space: nowrap;
  color: #666666;
}
#code {
  outline: none;
}
#submit_btn {
  width: 6rem;
  height: 0.9rem;
  background: linear-gradient(
    0deg,
    rgba(2, 130, 255, 1) 0%,
    rgba(32, 174, 255, 1) 100%
  );
  border-radius: 10px;
  font-size: 0.36rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin: 1.01rem auto 0px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue